import {
    FILES_LEGAL,
    FILES_CREDIT,
    FILES_PROJECT,
    FILES_REVIEW,
    FILES_ORDER,
    FILES_RESET
} from './mutation-types'

import { structure } from './state'
import $ from 'jquery'

export const _build = (node, payload) => {
    let id = 'I'+payload.id
    
    if(payload.linkedId)
        id = id+'L'+payload.linkedId
    
    if(!node[id])
        node[id] = $.extend(true, {}, structure)
    
    node[id].npk = payload.npk || ''
    node[id].isLoaded = true
    
    if(payload.forceSync) {
        node[id].total = 0
        node[id].data = []
    }
    
    for(let i=0; i<payload.files.length; i++) {
        node[id].data.push(payload.files[i])
        node[id].total++
    }
    
    return node
}

export default {
    [FILES_LEGAL](state, payload) {
        state.legal = _build(state.legal, payload)
    },
    
    [FILES_CREDIT](state, payload) {
        state.credit = _build(state.credit, payload)
    },
    
    [FILES_PROJECT](state, payload) {
        state.project = _build(state.project, payload)
    },
    
    [FILES_REVIEW](state, payload) {
        state.review = _build(state.review, payload)
    },
    
    [FILES_ORDER](state, payload) {
        state.order = _build(state.order, payload)
    },
    
    [FILES_RESET](state, payload) {
        let id = 'I'+payload.id
        
        if(payload.linkedId)
            id = id+'L'+payload.linkedId
        
        delete state[payload.type][id]
    }
}
